import React from "react";
import ReactDOM from "react-dom/client";
import {ChakraProvider, defaultSystem} from "@chakra-ui/react";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <React.StrictMode>
        {/*<ColorModeScript initialColorMode={theme.config.initialColorMode} />*/}
        <ChakraProvider value={defaultSystem}>
            <App />
        </ChakraProvider>
    </React.StrictMode>
);
